// extracted by mini-css-extract-plugin
export default {"price":"HightLightProductItem_price__r52kL","titleItem":"HightLightProductItem_titleItem__C0ef5"};